export default __webpack_public_path__ + "static/media/oneClick.fd3fcf36.png";